import { gql } from '@apollo/client'
import { useActionMutation, type UseActionResult, type UseMutationProps } from '@ztechapps/common.hook'
import type { CreateWorkOrderWithTasksArgs, WorkOrder } from '@ztechapps/common.contract'
import { workOrderDocumentFragment } from './graphql'

export const createWorkOrderWithTasksQuery = gql`
  mutation createWorkOrderWithTasks($input: CreateWorkOrderWithTasksArgs!) {
    createWorkOrderWithTasks(input: $input) {
      ...workOrderDocumentFragment
    }
  }
  ${workOrderDocumentFragment}
`

export const useCreateWorkOrderWithTasks = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, CreateWorkOrderWithTasksArgs> => {
  query = query ?? createWorkOrderWithTasksQuery

  return useActionMutation({
    query,
    ...props,
  })
}
